import React, { Component } from 'react';
import {BrowserRouter as Router, Link, Route} from "react-router-dom";
import './App.css';
import ResponsiveDrawer from "./Drawer";
import Menu from "./Menu";
import Footer from "./Footer";

class App extends Component {
  render() {
    return (
      <div className="App">
        <ResponsiveDrawer />
        <Menu />
        <Footer />
      </div>
    );
  }
}

export default App;
